// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/flutter.png",
    title: "SVAC",
    description:
      "A mobile app for video merging and compression in NodeJs that leverages efficient processing techniques to enhance performance and reduce file sizes while maintaining high video quality.",
    tech_stack: ["Flutter", "NodeJs", "ffmpeg"],
    github_url: "",
    demo_url: "",
  },
  {
    img: "/familytree.png",
    title: "Family Tree",
    description:
      "A web application that notifies users about nearby family events based on collected data, enhancing family connectivity and engagement through timely updates and personalized alerts.",
    tech_stack: ["React", "NodeJs", "MongoDB"],
    github_url: "",
    demo_url: "",
  },
  {
    img: "/doc-manager.png",
    title: "Doc Manager",
    description:
      "An all-in-one web application for managing all your cloud-based storage services, providing seamless access and organization of files from a single platform.",
    tech_stack: ["Vue.js", "NodeJs", "MongoDB", "GoogleAPIs", "DropBoxAPIs"],
    github_url: "",
    demo_url: "",
  },
  {
    img: "/appsheet-survey.png",
    title: "Survey",
    description:
      "An AppSheet application featuring a complex survey form with conditional fields that dynamically adjust based on user input, and generates a comprehensive Google Slides report upon completion.",
    tech_stack: ["Appsheet", "Appscript"],
    github_url: "",
    demo_url: "",
  },
  {
    img: "/gizmino.png",
    title: "Gizmino",
    description:
      "A web application interface for controlling IoT devices, offering real-time monitoring and seamless management of connected devices through an intuitive, user-friendly platform.",
    tech_stack: ["React", "NodeJs", "MQTT", "RabbitMQ"],
    github_url: "",
    demo_url: "",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "Typescript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    name: "Redux",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/angular/angular-original.svg",
    name: "Angular",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vuejs/vuejs-original.svg",
    name: "Vue.js",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original.svg",
    name: "PostgreSql",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/rabbitmq/rabbitmq-original.svg",
    name: "RabbitMq",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
    name: "AWS",
  },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
  //   name: "C",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //   name: "Java",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
  //   name: "Bootstrap",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
  //   name: "Material UI",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
  //   name: "Figma",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-plain.svg",
  //   name: "TailwindCSS",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
  //   name: "VS Code",
  // },
];

export const userInfo = {
  fullName: "Milan K Jain",
  firstName: "Milan",
  education: "Btech",
  email: "milanjain005@gmail.com",
  githubUrl: "https://github.com/milankj",
  linkedInUrl: "https://www.linkedin.com/in/milan-k-jain-798395242/"
}